import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld,
    //   children: [

    //   ]
    // },
    {
      path: "/",
      name: "home",
      meta: { title: "首页", type: 1 },
      component: () => import("../nav/home/index.vue"),
    },
    {
      path: "/notice",
      name: "notice",
      meta: { title: "通知公告", type: 1 },
      component: () => import("@/nav/notice/index.vue"),
      children: [
        {
          path: "/noticeDetail",
          component: () => import("@/nav/notice/noticeDetail.vue"),
          name: "noticeDetail",
          meta: { title: "通知公告详情" },
        },
      ],
    },
    {
      path: "/indexresearch",
      name: "indexresearch",
      meta: { title: "教研反馈", type: 1 },
      component: () => import("@/nav/home/jyfk.vue")
    },
    {
      path: "/studyMessageList",
      name: "studyMessageList",
      meta: { title: "" },
      component: () => import("@/nav/study/studyMessageList.vue"),
      children: [
        {
          path: "/studyMessageList",
          component: () => import("@/nav/study/studyMessageList.vue"),
          name: "studyMessageList",
          meta: { title: "系统消息" },
        },
      ],
    },
    {
      path: "/themeTeacher",
      name: "themeTeacher",
      meta: { title: "主题教研", type: 1 },
      component: () => import("../nav/themeTeacher/index.vue"),
      children: [
        {
          path: "/themeDetail",
          component: () => import("@/nav/themeTeacher/themeDetail.vue"),
          name: "themeDetail",
          meta: { title: "主题教研详情" },
        },
      ],
    },
    {
      path: "/specialZuo",
      name: "specialZuo",
      meta: { title: "专题讲座", type: 1 },
      component: () => import("../nav/specialZuo/index.vue"),
      children: [
        {
          path: "/zhtiDetail",
          component: () => import("@/nav/specialZuo/zhtiDetail.vue"),
          name: "zhtiDetail",
          meta: { title: "专题讲座详情" },
        },
      ],
    },
    {
      path: "/jiaoPeixun",
      name: "jiaoPeixun",
      meta: { title: "教材培训", type: 1 },
      component: () => import("../nav/jiaoPeixun/index.vue"),
      children: [
        {
          path: "/jiaocaiDetail",
          component: () => import("@/nav/jiaoPeixun/jiaocaiDetail.vue"),
          name: "jiaocaiDetail",
          meta: { title: "教材培训详情" },
        },
      ],
    },
    {
      path: "/service",
      name: "service",
      meta: { title: "命题服务", type: 1 },
      component: () => import("../nav/service/index.vue"),
      children: [
        {
          path: "/serviceDetail",
          component: () => import("@/nav/service/serviceDetail.vue"),
          name: "serviceDetail",
          meta: { title: "命题服务详情" },
        },
        {
          path: "/serviceVideo",
          component: () => import("@/nav/service/serviceVideo.vue"),
          name: "serviceVideo",
          meta: { title: "命题服务详情" },
        },
      ],
    },
    {
      path: "/teKecheng",
      name: "teKecheng",
      meta: { title: "特色课程", type: 1 },
      component: () => import("../nav/teKecheng/index.vue"),
      children: [
        {
          path: "/teseDetail",
          component: () => import("@/nav/teKecheng/teseDetail.vue"),
          name: "teseDetail",
          meta: { title: "特色课程详情" },
        },
      ],
    },
    {
      path: "/qyjy",
      name: "qyjy",
      meta: { title: "融合教研", type: 1 },
      component: () => import("../nav/Integrating/index.vue"),
      children: [
        {
          path: "/qyjyDetail",
          component: () => import("@/nav/Integrating/detail.vue"),
          name: "qyjyDetail",
          meta: { title: "融合教研详情" },
        },
        {
          path: "/viedeodetail",
          component: () => import("@/nav/Integrating/viedeodetail.vue"),
          name: "viedeodetail",
          meta: { title: "融合教研详情" },
        },
      ],
    },
    {
      path: "/resourceCenter",
      name: "resourceCenter",
      meta: { title: "资源中心", type: 1 },
      component: () => import("../nav/resourceCenter/index.vue"),
      children: [
        {
          path: "/resourceDetail",
          component: () => import("@/nav/resourceCenter/detail.vue"),
          name: "resourceDetail",
          meta: { title: "资源中心详情" },
        },
        {
          path: "/resourceVideoDetail",
          component: () => import("@/nav/resourceCenter/viedeodetail.vue"),
          name: "resourceVideoDetail",
          meta: { title: "资源中心详情" },
        },
      ],
    },
    {
      path: "/keliShow",
      name: "keliShow",
      meta: { title: "优质课展评", type: 1 },
      component: () => import("../nav/keliShow/index.vue"),
      children: [
        {
          path: "/keliDetail",
          component: () => import("@/nav/keliShow/keliDetail.vue"),
          name: "keliDetail",
          meta: { title: "优质课展评详情" },
        },
      ],
    },
    {
      path: "/liveShow",
      name: "liveShow",
      meta: { title: "直播列表", type: 1 },
      component: () => import("../nav/liveShow/index.vue"),
      children: [
        {
          path: "/liveDetail",
          component: () => import("@/nav/liveShow/liveDetail.vue"),
          name: "liveDetail",
          meta: { title: "直播详情" },
        },
      ],
    },
    {
      path: "/team",
      name: "team",
      meta: { title: "专家团队", type: 1 },
      component: () => import("../nav/team/index.vue"),
      hidden: false,
      children: [
        {
          path: "/teamDetail",
          component: () => import("@/nav/team/teamDetail.vue"),
          name: "teamDetail",
          meta: { title: "专家团队详情" },
          hidden: true,
          children: [
            {
              path: "/teamtypeDetail",
              component: () => import("@/nav/team/teamtypeDetail.vue"),
              name: "teamtypeDetail",
              meta: { title: "专家团队详情" },
              hidden: true,
            },
            {
              path: "/teamVideoDetail",
              component: () => import("@/nav/team/teamVideoDetail.vue"),
              name: "teamVideoDetail",
              meta: { title: "专家团队详情" },
              hidden: true,
            },
          ],
        },
      ],
    },
    {
      path: "/school",
      name: "school",
      meta: { title: "基地学校", type: 1 },
      component: () => import("../nav/school/index.vue"),
      children: [
        {
          path: "/schoolDetail",
          component: () => import("@/nav/school/schoolDetail.vue"),
          name: "schoolDetail",
          meta: { title: "学校详情" },
          children: [
            {
              path: "/schoolList",
              component: () => import("@/nav/school/schoolList.vue"),
              name: "schoolList",
              meta: { title: "学校分类列表" },
              children: [
                {
                  path: "/schoolListDetail",
                  component: () => import("@/nav/school/schoolListDetail.vue"),
                  name: "schoolListDetail",
                  meta: { title: "学校分类详情" },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "/principal",
      name: "principal",
      meta: { title: "名校长工作室", type: 1 },
      component: () => import("../nav/principal/index.vue"),
    },
    {
      path: "/principalIndex",
      name: "principalIndex",
      meta: { title: "名校长工作室", type: 1 },
      component: () => import("../nav/principal/principalIndex.vue"),
      children: [
        {
          path: "/principalStudio",
          component: () => import("@/nav/principal/principalStudio.vue"),
          name: "principalStudio",
          meta: { title: "名校长工作室-首页" },
        },
        {
          path: "/principalMember",
          component: () => import("@/nav/principal/principalMember.vue"),
          name: "principalMember",
          meta: { title: "名校长工作室-成员" },
        },
        {
          path: "/principalDetail",
          component: () => import("@/nav/principal/principalDetail.vue"),
          name: "principalDetail",
          meta: { title: "名校长工作室-详情" },
        },
        {
          path: "/principalApply",
          component: () => import("@/nav/principal/principalApply.vue"),
          name: "principalApply",
          meta: { title: "名校长工作室-申请加入" },
        },
        {
          path: "/principalApplyList",
          component: () => import("@/nav/principal/principalApplyList.vue"),
          name: "principalApplyList",
          meta: { title: "名校长工作室-成员审核" },
        },
        {
          path: "/principalApplyDetail",
          component: () =>
            import("@/nav/principal/principalApplyDetail.vue"),
          name: "principalApplyDetail",
          meta: { title: "名校长工作室-审核详情" },
        },
        {
          path: "/principalvideo",
          component: () => import("@/nav/principal/principalvideo.vue"),
          name: "principalvideo",
          meta: { title: "视频资源" },
        },
      ],
    },
    {
      path: "/principalforum",
      name: "principalforum",
      meta: { title: "校长论坛", type: 1 },
      component: () => import("../nav/principal/forum.vue"),
      children: [
        {
          path: "/principalviedeodetail",
          component: () => import("@/nav/principal/viedeodetail.vue"),
          name: "principalviedeodetail",
          meta: { title: "校长论坛详情" },
        },
      ],
    },
    {
      path: "/teacher",
      name: "teacher",
      meta: { title: "名师工作室", type: 1 },
      component: () => import("../nav/teacher/index.vue"),
    },
    {
      path: "/teacherIndex",
      name: "teacherIndex",
      meta: { title: "名师工作室", type: 1 },
      component: () => import("../nav/teacher/teacherIndex.vue"),
      children: [
        {
          path: "/teacherStudio",
          component: () => import("@/nav/teacher/teacherStudio.vue"),
          name: "teacherStudio",
          meta: { title: "名师工作室-首页" },
        },
        {
          path: "/teacherMember",
          component: () => import("@/nav/teacher/teacherMember.vue"),
          name: "teacherMember",
          meta: { title: "名师工作室-成员" },
        },
        {
          path: "/teacherDetail",
          component: () => import("@/nav/teacher/teacherDetail.vue"),
          name: "teacherDetail",
          meta: { title: "名师工作室-详情" },
        },
        {
          path: "/teacherApply",
          component: () => import("@/nav/teacher/teacherApply.vue"),
          name: "teacherApply",
          meta: { title: "名师工作室-申请加入" },
        },
        {
          path: "/teacherApplyList",
          component: () => import("@/nav/teacher/teacherApplyList.vue"),
          name: "teacherApplyList",
          meta: { title: "名师工作室-成员审核" },
        },
        {
          path: "/teacherApplyDetail",
          component: () => import("@/nav/teacher/teacherApplyDetail.vue"),
          name: "teacherApplyDetail",
          meta: { title: "名师工作室-审核详情" },
        },
        {
          path: "/teachervideo",
          component: () => import("@/nav/teacher/teachervideo.vue"),
          name: "teachervideo",
          meta: { title: "视频资源" },
        },
      ],
    },
    // 添加零碳工作坊路由
    {
      path: "/zeroCarbon",
      name: "zeroCarbon",
      meta: { title: "零碳工作坊", type: 1 },
      component: () => import("../nav/zeroCarbon/index.vue"),
    },
    {
      path: "/zeroCarbonIndex",
      name: "zeroCarbonIndex",
      meta: { title: "零碳工作坊", type: 1 },
      component: () => import("../nav/zeroCarbon/teacherIndex.vue"),
      children: [
        {
          path: "/zeroCarbonStudio",
          component: () => import("@/nav/zeroCarbon/teacherStudio.vue"),
          name: "zeroCarbonStudio",
          meta: { title: "零碳工作坊-首页" },
        },
        {
          path: "/zeroCarbonMember",
          component: () => import("@/nav/zeroCarbon/teacherMember.vue"),
          name: "zeroCarbonMember",
          meta: { title: "零碳工作坊-成员" },
        },
        {
          path: "/zeroCarbonDetail",
          component: () => import("@/nav/zeroCarbon/teacherDetail.vue"),
          name: "zeroCarbonDetail",
          meta: { title: "零碳工作坊-详情" },
        },
        {
          path: "/zeroCarbonApply",
          component: () => import("@/nav/zeroCarbon/teacherApply.vue"),
          name: "zeroCarbonApply",
          meta: { title: "零碳工作坊-申请加入" },
        },
        {
          path: "/zeroCarbonApplyList",
          component: () => import("@/nav/zeroCarbon/teacherApplyList.vue"),
          name: "zeroCarbonApplyList",
          meta: { title: "零碳工作坊-成员审核" },
        },
        {
          path: "/zeroCarbonApplyDetail",
          component: () => import("@/nav/zeroCarbon/teacherApplyDetail.vue"),
          name: "zeroCarbonApplyDetail",
          meta: { title: "零碳工作坊-审核详情" },
        },
        {
          path: "/zeroCarbonvideo",
          component: () => import("@/nav/zeroCarbon/teachervideo.vue"),
          name: "zeroCarbonvideo",
          meta: { title: "视频资源" },
        },
      ],
    },
    {
      path: "/study",
      name: "study",
      meta: { title: "学习中心", type: 1 },
      component: () => import("../nav/study/index.vue"),
      children: [
        {
          path: "/studyDo",
          component: () => import("@/nav/study/studyDo.vue"),
          name: "studyDo",
          meta: { title: "待办/已办" },
        },
        {
          path: "/studyGroup",
          component: () => import("@/nav/study/studyGroup.vue"),
          name: "studyGroup",
          meta: { title: "我的群组" },
        },
        {
          path: "/studyGroupDetail",
          component: () => import("@/nav/study/studyGroupDetail.vue"),
          name: "studyGroupDetail",
          meta: { title: "我的群组" },
        },
        {
          path: "/studyGroupDetailList",
          component: () => import("@/nav/study/studyGroupDetailList.vue"),
          name: "studyGroupDetailList",
          meta: { title: "我的群组" },
        },
        {
          path: "/studygroupvideo",
          component: () => import("@/nav/study/groupvideo.vue"),
          name: "studygroupvideo",
          meta: { title: "视频资源" },
        },
        {
          path: "/studyMyTask",
          component: () => import("@/nav/study/studyMyTask.vue"),
          name: "studyMyTask",
          meta: { title: "我的任务" },
        },
        {
          path: "/studyAddTask",
          component: () => import("@/nav/study/studyAddTask.vue"),
          name: "studyAddTask",
          meta: { title: "创建任务" },
        },
        {
          path: "/studyMyactivity",
          component: () => import("@/nav/study/studyMyactivity.vue"),
          name: "studyMyactivity",
          meta: { title: "我的活动" },
        },
        {
          path: "/studyAddActivity",
          component: () => import("@/nav/study/studyAddActivity.vue"),
          name: "studyAddActivity",
          meta: { title: "创建活动" },
        },
        {
          path: "/studyMyactivityAddfeng",
          component: () => import("@/nav/study/studyMyactivityAddfeng.vue"),
          name: "studyMyactivityAddfeng",
          meta: { title: "上传风采" },
        },
        // {
        //   path:'/studyInstructionalDesign',
        //   component: () => import("@/nav/study/studyInstructionalDesign.vue"),
        //   name: "studyInstructionalDesign",
        //   meta: { title: "教学设计" }
        // },
        // {
        //   path:'/studyAddInstructional',
        //   component: () => import("@/nav/study/studyAddInstructional.vue"),
        //   name: "studyAddInstructional",
        //   meta: { title: "教学设计" }
        // },
        // {
        //   path:'/studyReflect',
        //   component: () => import("@/nav/study/studyReflect.vue"),
        //   name: "studyReflect",
        //   meta: { title: "教学反思" }
        // },
        // {
        //   path:'/studyAddReflect',
        //   component: () => import("@/nav/study/studyAddReflect.vue"),
        //   name: "studyAddReflect",
        //   meta: { title: "教学反思" }
        // },
        // {
        //   path:'/studyMyLession',
        //   component: () => import("@/nav/study/studyMyLession.vue"),
        //   name: "studyMyLession",
        //   meta: { title: "我的课例" }
        // },
        // {
        //   path:'/studyAddMyLession',
        //   component: () => import("@/nav/study/studyAddMyLession.vue"),
        //   name: "studyAddMyLession",
        //   meta: { title: "我的课例" }
        // },
        // {
        //   path:'/studyStudyNotes',
        //   component: () => import("@/nav/study/studyStudyNotes.vue"),
        //   name: "studyStudyNotes",
        //   meta: { title: "学习笔记" }
        // },
        {
          path: "/studySummary",
          component: () => import("@/nav/study/studySummary.vue"),
          name: "studySummary",
          meta: { title: "教研总结" },
        },
        {
          path: "/studyAddSummary",
          component: () => import("@/nav/study/studyAddSummary.vue"),
          name: "studyAddSummary",
          meta: { title: "教研总结" },
        },
        // {
        //   path:'/studyStudyHistory',
        //   component: () => import("@/nav/study/studyStudyHistory.vue"),
        //   name: "studyStudyHistory",
        //   meta: { title: "学习记录" }
        // },
        // {
        //   path:'/studyInteractiveEssay',
        //   component: () => import("@/nav/study/studyInteractiveEssay.vue"),
        //   name: "studyInteractiveEssay",
        //   meta: { title: "互动随笔" }
        // },
        {
          path: "/studyMyCollection",
          component: () => import("@/nav/study/studyMyCollection.vue"),
          name: "studyMyCollection",
          meta: { title: "我的收藏" },
        },
        {
          path: "/studyMySpace",
          component: () => import("@/nav/study/studyMySpace.vue"),
          name: "studyMySpace",
          meta: { title: "我的空间" },
        },
        {
          path: "/studyApprove",
          component: () => import("@/nav/study/studyApprove.vue"),
          name: "studyApprove",
          meta: { title: "我的审核" },
        },
        {
          path: "/studySpDetail",
          component: () => import("@/nav/study/studySpDetail.vue"),
          name: "studySpDetail",
          meta: { title: "我的审核" },
        },
        {
          path: "/studyPower",
          component: () => import("@/nav/study/studyPower.vue"),
          name: "studyPower",
          meta: { title: "我的权限" },
        },
        // {
        //   path:'/studyNotesdetail',
        //   component: () => import("@/nav/study/studyNotesdetail.vue"),
        //   name: "studyNotesdetail",
        //   meta: { title: "查看笔记" }
        // },
        {
          path: "/studyMyLike",
          component: () => import("@/nav/study/studyMyLike.vue"),
          name: "studyMyLike",
          meta: { title: "我的点赞" },
        },
        {
          path: "/studyMyConcern",
          component: () => import("@/nav/study/studyMyConcern.vue"),
          name: "studyMyConcern",
          meta: { title: "我的关注" },
        },
        {
          path: "/mystudy",
          component: () => import("@/nav/study/myStudy.vue"),
          name: "myStudy",
          meta: { title: "我的学习" },
        },
        {
          path: "/teachingstudy",
          component: () => import("@/nav/study/teachingStudy.vue"),
          name: "teachingStudy",
          meta: { title: "我的教研" },
        },
        {
          path: "/studysign",
          component: () => import("@/nav/study/studysign.vue"),
          name: "studysign",
          meta: { title: "我的签到" },
        },
        {
          path: "/studysigndetail",
          component: () => import("@/nav/study/studysigndetail.vue"),
          name: "studysigndetail",
          meta: { title: "签到详情" },
        },
        {
          path: "/studyCertificate",
          component: () => import("@/nav/study/studyCertificate.vue"),
          name: "studyCertificate",
          meta: { title: "我的证书" },
        },
        {
          path: "/studyCertificateAdd",
          component: () => import("@/nav/study/studyAddcertificate.vue"),
          name: "studyCertificateAdd",
          meta: { title: "证书详情" },
        },
        {
          path: "/studySchool",
          component: () => import("@/nav/study/studySchool.vue"),
          name: "studySchool",
          meta: { title: "共同体活动" },
        },
        {
          path: "/studySchooladd",
          component: () => import("@/nav/study/studySchooladd.vue"),
          name: "studySchooladd",
          meta: { title: "共同体活动详情" },
        },
        {
          path: "/studyUnionSchool",
          component: () => import("@/nav/study/studyUnionSchool.vue"),
          name: "studyUnionSchool",
          meta: { title: "教联体活动" },
        },
        {
          path: "/studyUnionSchooladd",
          component: () => import("@/nav/study/studyUnionSchooladd.vue"),
          name: "studyUnionSchooladd",
          meta: { title: "教联体活动详情" },
        },
      ],
    },
    {
      path: "/manage",
      name: "manage",
      meta: { title: "管理中心", type: 1 },
      component: () => import("../nav/manage/index.vue"),
      children: [
        {
          path: "/manageCenter",
          component: () => import("@/nav/manage/manageCenter.vue"),
          name: "manageCenter",
          meta: { title: "管理中心" },
        },
        {
          path: "/manageGroup",
          component: () => import("@/nav/manage/manageGroup.vue"),
          name: "manageGroup",
          meta: { title: "群组管理" },
        },
        {
          path: "/manageGroupAdd",
          component: () => import("@/nav/manage/manageGroupAdd.vue"),
          name: "manageGroupAdd",
          meta: { title: "创建群组" },
        },
        {
          path: "/manageGroupDetail",
          component: () => import("@/nav/manage/manageGroupDetail.vue"),
          name: "manageGroupDetail",
          meta: { title: "群组详情" },
        },
        {
          path: "/manageGroupDetailList",
          component: () => import("@/nav/manage/manageGroupDetailList.vue"),
          name: "manageGroupDetailList",
          meta: { title: "群组详情" },
        },
        {
          path: "/manageActivity",
          component: () => import("@/nav/manage/manageActivity.vue"),
          name: "manageActivity",
          meta: { title: "活动管理" },
        },
        {
          path: "/manageActivityAdd",
          component: () => import("@/nav/manage/manageActivityAdd.vue"),
          name: "manageActivityAdd",
          meta: { title: "创建活动" },
        },
        {
          path: "/managePlan",
          component: () => import("@/nav/manage/managePlan.vue"),
          name: "managePlan",
          meta: { title: "计划管理" },
        },
        {
          path: "/manageAddPlan",
          component: () => import("@/nav/manage/manageAddPlan.vue"),
          name: "manageAddPlan",
          meta: { title: "创建计划" },
        },
        {
          path: "/manageAddTask",
          component: () => import("@/nav/manage/manageAddTask.vue"),
          name: "manageAddTask",
          meta: { title: "创建任务" },
        },
        {
          path: "/manageTask",
          component: () => import("@/nav/manage/manageTask.vue"),
          name: "manageTask",
          meta: { title: "任务管理" },
        },
        {
          path: "/manageActivityAddfeng",
          component: () => import("@/nav/manage/manageActivityAddfeng.vue"),
          name: "manageActivityAddfeng",
          meta: { title: "活动风采" },
        },
      ],
    },
    {
      path: "/history",
      name: "history",
      meta: { title: "发展历程" },
      component: () => import("../nav/history/index.vue"),
    },
    {
      path: "/aboutUs",
      name: "aboutUs",
      meta: { title: "关于我们" },
      component: () => import("../nav/aboutUs/index.vue"),
    },
  ],
});


// WEBPACK FOOTER //
// ./src/router/index.js